import type { EdgeEntityData } from '@ipfabric/utils';
import { canOpenDeviceEdgeEntity } from './canOpenDeviceEdgeEntity';

export const hasEntityInvalidEdgeProtocol = (
  edges?: EdgeEntityData[],
): boolean =>
  edges?.some((edge) => !canOpenDeviceEdgeEntity(edge.protocol)) ?? false;
